import { JSX } from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    SelectField,
    ReferenceField,
    TopToolbar,
    EditButton,
    useRecordContext
} from 'react-admin';
import {
    Grid,
    LinearProgress
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";

const ShowActions: () => JSX.Element = (): JSX.Element => {

    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowAddressTitle: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    if (!record) return null;
    return <span>{ "Customer Address - " + record.id }</span>
}

export const AdminAddressShow: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return(
        <Show actions={ <ShowActions /> } title={ <ShowAddressTitle /> }>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id" />
                        <TextField source="line_one" />
                        <TextField source="line_two" />
                        <TextField source="city" />

                    </SimpleShowLayout>
                </Grid>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="county" />
                        <TextField source="postcode" />
                        { (loading) &&
                            <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                        }
                        { (!loading) &&
                            <SelectField
                                choices={ loadedCountries }
                                source="country"
                            />
                        }

                        <ReferenceField
                            label="Company"
                            source="company"
                            reference="companies"
                            link="edit">
                            <TextField source="name" />
                        </ReferenceField>
                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}